/*
  BNH — Hediye seçeneklerinde "değeri" rozeti.

  Ürün sayfasındaki "Hediye 2. Renk Keseyi Seçiniz" alanı, müşteriye
  ne kazandığını söylemiyordu: kese tek başına satılan bir ürün ama
  sayfada bunun bir bedeli olduğuna dair hiçbir işaret yoktu.

  Buradaki rozet o ürünün MAĞAZADAKİ GERÇEK fiyatını çekip üstünü
  çizerek gösteriyor. Fiyat sabit yazılmıyor; ilgili ürünün Shopify
  verisinden okunuyor, böylece fiyat değişince rozet de değişiyor.

  Eşleştirme aşağıdaki HEDIYELER listesinde. Yeni bir hediye alanı
  eklenirse (ör. hediye askı) buraya bir satır eklemek yeterli.
*/
(function () {
  var HEDIYELER = [
    { test: /kese/i,          handle: 'soft-pouches' },
    { test: /ask[ıi]/i,       handle: 'keseler-kopya' },
    { test: /zincir|i̇?nci/i, handle: 'zincir-i̇nciler' }
  ];

  var cache = {};

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.') + 'TL';
  }

  /* Ürünün "normal" fiyatı: en çok tekrar eden varyant fiyatı.
     (Birkaç renk indirimli olabiliyor; onlar ölçüyü kaydırmasın.) */
  function typicalPrice(product) {
    var counts = {}, best = null, bestN = 0;
    product.variants.forEach(function (v) {
      counts[v.price] = (counts[v.price] || 0) + 1;
      if (counts[v.price] > bestN) { bestN = counts[v.price]; best = v.price; }
    });
    return best;
  }

  function load(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function decorate(stack, label) {
    if (stack.dataset.nbGift) return;

    var text = label.textContent || '';
    var match = null;
    for (var i = 0; i < HEDIYELER.length; i++) {
      if (HEDIYELER[i].test.test(text)) { match = HEDIYELER[i]; break; }
    }
    if (!match) return;

    stack.dataset.nbGift = '1';

    load(match.handle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) return;
      var price = typicalPrice(product);
      if (!price) return;

      var band = document.createElement('div');
      band.className = 'bnh-gift-band';
      band.innerHTML =
        '<span class="bnh-gift-band__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" ' +
            'stroke="currentColor" stroke-width="1.2">' +
            '<rect x="2.5" y="9" width="19" height="12.5"/>' +
            '<path d="M1 6h22v3H1zM12 6v15.5"/>' +
            '<path d="M12 6S10.5 2.5 8 2.5A2.5 2.5 0 0 0 8 7.5c2 0 4-1.5 4-1.5z"/>' +
            '<path d="M12 6s1.5-3.5 4-3.5a2.5 2.5 0 0 1 0 5c-2 0-4-1.5-4-1.5z"/>' +
          '</svg>' +
        '</span>' +
        '<span class="bnh-gift-band__text">' +
          '<span class="bnh-gift-band__line">Seçtiğiniz renk siparişinize ücretsiz eklenir</span>' +
        '</span>' +
        '<span class="bnh-gift-band__price">' +
          '<s>' + money(price) + '</s>' +
          '<b>Ücretsiz</b>' +
        '</span>';

      var container = label.closest('.po-label-container') || label.parentElement;
      if (container && container.parentElement) {
        container.parentElement.insertBefore(band, container.nextSibling);
      } else {
        stack.insertBefore(band, stack.firstChild);
      }
      stack.classList.add('bnh-has-gift-value');
    });
  }

  /* ---------------------------------------------------------
     "Bu Ürüne Özel Teklif" satırları
     Uygulama fiyatı düz metin basıyor: "399 TL yerine 299 TL".
     Eski fiyatın üstünü çizip yenisini öne çıkarıyoruz; kazanç
     ayrı bir etikette.
     --------------------------------------------------------- */
  function offers() {
    var nodes = document.querySelectorAll('p.po_helptext_value');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.nbOffer) continue;

      var m = (el.textContent || '').match(
        /^\s*([\d.,]+\s*(?:TL|₺))\s*yerine\s*([\d.,]+\s*(?:TL|₺))\s*$/i
      );
      if (!m) continue;

      el.dataset.nbOffer = '1';
      el.classList.add('bnh-offer-price');

      /* Kazanç etiketi yok: üstü çizili fiyat + yeni fiyat zaten
         farkı gösteriyor, üçüncü bir rakam fiyat sanılıyordu. */
      el.innerHTML = '<s>' + m[1].trim() + '</s><b>' + m[2].trim() + '</b>';

      var row = el.closest('label.po-option__value--horizontal');
      if (row) row.classList.add('bnh-offer-row');
    }
  }

  function run() {
    offers();
    var stacks = document.querySelectorAll('.po-stack');
    for (var i = 0; i < stacks.length; i++) {
      var label = stacks[i].querySelector('label.po-label');
      if (!label) continue;
      if (!/hediye/i.test(label.textContent || '')) continue;
      decorate(stacks[i], label);
    }
  }

  function init() {
    run();
    /* Uygulama alanları geç basılıyor ve varyant değişince yeniden
       çiziliyor. */
    var mo = new MutationObserver(function () { run(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(run, 1200);
    setTimeout(run, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
